import React from "react";

// Img
import brideImg from "../../assets/png/bride.png";

// Mui
import { Box, ImageListItem, Tooltip } from "@mui/material";

// Jds
import { Button, Container, Icon, Image, ListBlock, Text } from "@jds/core";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { addParamsURL } from "../../util/helper";
export default function Face({
  data: faceData,
  setFaceData = () => {},
  setEditModalClose = () => {},
  isFaceLisModalClosed = true,
  setIsFaceModalClose = () => {},
  onClickNavigate = () => {},
}) {
  return (
    <>
      <ImageListItem>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginRight: "16px",
            width: "184px",
          }}
        >
          <Box
            id={faceData?.clusterId + ""}
            sx={{
              cursor: "pointer",
              width: "100%",
              height: "184px",
              borderRadius: "50%",
              overflow: "hidden",
            }}
            onClick={() => {
              setFaceData(faceData);
              // setIsFaceModalClose(false);
              onClickNavigate();
            }}
          >
            {/* <Image
            src={faceData?.mediaUrl || brideImg}
            alt="face"
            aspectRatio="round"
          /> */}
            {faceData?.mediaUrl ? (
              <LazyLoadImage
                alt="face"
                effect="blur"
                src={`${faceData?.mediaUrl}&size=s` || ""}
                placeholderSrc={`${faceData?.mediaUrl}&size=s` || ""}
                width={184}
                height={184}
              />
            ) : (
              <Image
                // src={faceData?.mediaUrl || brideImg}
                alt="face"
                aspectRatio="round"
              />
            )}
          </Box>
          <div
            onClick={(e) => {
              e.stopPropagation();
              if (faceData?.username) {
                setEditModalClose(false);
                setFaceData(faceData);
              }
            }}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              padding: "12px",
              color: "var(--color-primary-50)",
            }}
          >
            <Tooltip title={faceData?.username || ""} position="bottom" arrow>
              <p
                style={{
                  fontFamily: "var(--font-medium)",
                  whiteSpace: "nowrap",
                  maxWidth: "150px",
                  width: "100%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  margin: "0 !important",

                  fontSize: "18px",
                }}
              >
                {faceData?.username}{" "}
              </p>
            </Tooltip>
            {faceData?.username && <IcPen />}
          </div>
        </div>
      </ImageListItem>
    </>
  );
}

export const IcPen = () => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 4.5a3.54 3.54 0 00-5 0l-.29.29 5 5 .29-.29a3.54 3.54 0 000-5zm-13.95 9a3 3 0 00-.76 1.3l-1 3.65a1.5 1.5 0 001.81 1.81l3.65-1.05a3 3 0 001.3-.76l7.24-7.24-5-5-7.24 7.29z"
      fill="currentColor"
    ></path>
  </svg>
);
